import axios from "axios";
import config from "../../config/config";
import type {
  AdminOrderDetail,
  AdminOrdersListParams,
  AdminOrdersPage,
} from "./orders.types";

const API_URL = `${config.apiBaseUrl}/admin/orders`;

const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: config.defaultTimeout,
});

axiosClient.interceptors.request.use(
  (requestConfig) => {
    const token = localStorage.getItem("token");
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

function buildListQuery(params: AdminOrdersListParams): string {
  const searchParams = new URLSearchParams();

  if (params.page != null) searchParams.set("page", String(params.page));
  if (params.pageSize != null) searchParams.set("pageSize", String(params.pageSize));
  if (params.search?.trim()) searchParams.set("search", params.search.trim());
  if (params.orderStatus) searchParams.set("orderStatus", params.orderStatus);
  if (params.paymentStatus) searchParams.set("paymentStatus", params.paymentStatus);
  if (params.provider) searchParams.set("provider", params.provider);
  if (params.method) searchParams.set("method", params.method);
  if (params.packageId?.trim()) searchParams.set("packageId", params.packageId.trim());
  if (params.from) searchParams.set("from", params.from);
  if (params.to) searchParams.set("to", params.to);
  if (params.sort) searchParams.set("sort", params.sort);

  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export const fetchAdminOrders = async (
  params: AdminOrdersListParams = {}
): Promise<AdminOrdersPage> => {
  const response = await axiosClient.get<AdminOrdersPage>(buildListQuery(params));
  return response.data;
};

export const fetchAdminOrderById = async (orderId: string): Promise<AdminOrderDetail> => {
  const response = await axiosClient.get<AdminOrderDetail>(`/${encodeURIComponent(orderId)}`);
  return response.data;
};

export const isAdminOrderNotFound = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 404;
